"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./ProductSummary.scss");
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _ProductSummaryMethods = require("./ProductSummaryMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ProductSummary = _ref => {
  let {
    content
  } = _ref;
  const {
    summaryCard,
    columns,
    labels,
    version,
    variant
  } = content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mxp-product-summary"
  }, (0, _ProductSummaryMethods.SummaryCard)(summaryCard, labels, version, variant), (0, _ProductSummaryMethods.SummaryColumnSection)(columns));
};
var _default = ProductSummary;
exports.default = _default;